import { isWritableAbsenceType, WritableAbsenceType } from './writable-absence-type';

/**
 * JSON body for V2 Absence create/update (`ModifyAbsenceReportModel`).
 * `companyId` belongs on the create route, not in this payload.
 */
export interface ModifyAbsenceReportModel {
  date: string;
  dateFrom?: string;
  dateTo?: string;
  description: string;
  comments?: string;
  duration?: string;
  absenceType: WritableAbsenceType;
  reportTimeZone?: string;
  includeSaturday?: boolean;
  includeSunday?: boolean;
}

export function toModifyAbsenceReportBody(request: ModifyAbsenceReportModel): ModifyAbsenceReportModel {
  if (!isWritableAbsenceType(request.absenceType)) {
    throw new Error(`Unsupported absenceType for write: ${String(request.absenceType)}`);
  }

  const body: ModifyAbsenceReportModel = {
    date: request.date,
    description: request.description,
    absenceType: request.absenceType
  };

  if (request.dateFrom !== undefined) {
    body.dateFrom = request.dateFrom;
  }
  if (request.dateTo !== undefined) {
    body.dateTo = request.dateTo;
  }
  if (request.comments !== undefined) {
    body.comments = request.comments;
  }
  if (request.duration) {
    body.duration = request.duration;
  }
  if (typeof request.includeSaturday === 'boolean') {
    body.includeSaturday = request.includeSaturday;
  }
  if (typeof request.includeSunday === 'boolean') {
    body.includeSunday = request.includeSunday;
  }

  return body;
}
